/**
 * 媒体图库
 */
if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'), // 主图
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'), // 缩略图
        };

        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        /**
         * 缩略图
         * 接收自定义事件
         * currentPage: 当前帧
         * currentElement: 当前元素
         */
        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );

        // 单击缩略图帧，展示对应帧主图
        const _self = this;
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch.querySelector("button").addEventListener(
              "click",
              function () {
                _self.updateThumbnailModel(mediaToSwitch.dataset.target);
              },
              false
            );
          });
        if (this.dataset.desktopLayout !== "stacked" && this.mql.matches)
          this.removeListSemantic();

        // 接收数据，仅仅用于会展自定义缩略图UI功能
        window.addEventListener(
          "message",
          function (e) {
            const { type, data } = e.data || {};
            const { href, index } = data || {};

            if (
              type !== "main-product-brand-thumbnail-callback" ||
              href !== window.location.href
            )
              return;

            // 同步事务
            const thumbnailsEls =
              _self.elements.thumbnails.querySelectorAll("[data-target]");
            const variantThumbnailElsArray = Array.from(thumbnailsEls);

            // 需要过滤掉因为变体逻辑隐藏的元素
            const variantThumbnailElsList = variantThumbnailElsArray.filter(
              (item) => {
                const variantElStyle = document.defaultView.getComputedStyle(
                  item,
                  null
                );
                return variantElStyle && variantElStyle.display !== "none";
              }
            );
            const el = variantThumbnailElsList[index];
            const target = el.dataset.target;
            _self.updateThumbnailModel(el.dataset.target);
          },
          false
        );
      }

      // 同步事务
      updateThumbnailModel(target) {
        this.setActiveMedia(target, false);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.elements.thumbnails.slider) {
this.elements.thumbnails.slider.scrollTo({
left: thumbnail.offsetLeft,
});
} else {
return; // 如果未定义滑块，则退出函数
}
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
